import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const FormAddAds = () => {
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState("");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [broadcast_status, setBroadcasStatus] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const loadImage = (e) => {
    const image = e.target.files[0];
    setFile(image);
    setPreview(URL.createObjectURL(image));
  };

  const saveAds = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("subtitle", subtitle);
    formData.append("broadcast_status", broadcast_status);
    try {
      await axios.post(`${API_BASE_URL}/ads`, formData, {
        headers: {
          "Content-type": "multipart/form-data",
          'X-API-Key': API_KEY
        },
      });
      navigate("/ads");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-centered">
          <h1 className="title is-size-5">Create Advertisement</h1>
          <div className="card is-shadowless">
            <form onSubmit={saveAds}>
              <p className="has-text-left has-text-danger">{msg}</p>
              <div className="field">
                <label className="label is-size-6">Title</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Title"
                  />
                </div>
              </div>
              <div className="field">
                  <label className="label">Subtitle</label>
                  <div className="control">
                      <textarea
                          className="textarea"
                          value={subtitle}
                          onChange={(e) => setSubtitle(e.target.value)}
                          placeholder="Subtitle"
                          rows="3"
                          required
                      ></textarea>
                  </div>
              </div>
              
              <div className="field">
                <label className="label">Broadcast Status</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      value={broadcast_status}
                      onChange={(e) => setBroadcasStatus(e.target.value)}
                    >
                      <option value="">Select Broadcast Status</option>
                      <option value="ON">ON</option>
                      <option value="OFF">OFF</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="field">
                <label className="label">Image</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        className="file-input"
                        onChange={loadImage}
                      />
                      <span className="file-cta">
                        <span className="file-label">Choose a file...</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              {preview ? (
                <figure className="image is-2by1 mb-2">
                  <img src={preview} alt="Preview Image" />
                </figure>
              ) : (
                ""
              )}
              <div className="field">
                <div className="control">
                  <Link to="/ads">
                  <button className="button is-small is-warning mr-1">
                    Cancel
                  </button>
                  </Link>
                  <button type="submit" className="button is-small is-success">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAddAds;
